module.exports = __webpack_public_path__ + "img/1.a3d29203.jpg";